import { render, staticRenderFns } from "./SettingSection.vue?vue&type=template&id=0493d42b&scoped=true&"
import script from "./SettingSection.vue?vue&type=script&lang=js&"
export * from "./SettingSection.vue?vue&type=script&lang=js&"
import style0 from "./SettingSection.vue?vue&type=style&index=0&id=0493d42b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0493d42b",
  null
  
)

export default component.exports